export const trackEvent = (name, params = {}) => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
        window.gtag("event", name, { page_path: window.location.pathname, ...params });
    }
};
